export default "__VITE_ASSET__DyP9BCmD__"